import { getDetailsByRoom } from './getDetailsByRoom';

const isRoomMatch = (left, right) => left === right || String(left) === String(right);

export const getRoomSelectionData = ({ details = [], occupation = [] } = {}) => {
  const detailsByRoom = getDetailsByRoom(details).filter(({ id } = {}) =>
    occupation.some(({ id: roomId } = {}) => id !== undefined && isRoomMatch(roomId, id)),
  );

  if (detailsByRoom.length > 0) {
    return detailsByRoom.map((detail = {}) => ({
      detail,
      room: { id: detail.id, index: detail.detailIndex },
      roomOccupation: occupation.find(({ id } = {}) => id !== undefined && isRoomMatch(id, detail.id)),
    }));
  }

  return occupation.map((roomOccupation = {}, index) => ({
    room: { id: roomOccupation.id, index },
    roomOccupation,
  }));
};
